import { EventForPlanningDto } from './event-for-planning.dto';

export class GetLeadEventsResponse {
    events: EventForPlanningDto[];
    businessHours: any;

    constructor(events: EventForPlanningDto[], businessHours) {
        this.events = events;
        this.businessHours = businessHours;
    }
}
